import { ScreenerFilter } from '@toggle/toggle';

import { FilterState } from '~/hooks/use-filter-actions/useFilterActions';
import { watchlistFilter } from '~/views/screener/use-screener-store/filter-utils';
import { useScreenerStore } from '~/views/screener/use-screener-store/useScreenerStore';

export const screenerFilter: ScreenerFilter = {
  key: 'screener',
  name: 'Screener',
  visible: true,
  searchable: false,
  locked: true,
  category: 'Universe',
  config: {
    multiselect: true,
    name: 'Screener',
    options: [],
  },
};

const mapFilter = (
  filters: FilterState,
  key: string
): ScreenerFilter | undefined => {
  const filter = filters.allFilters.find(filter => filter.key === key);
  return (
    filter && {
      ...filter,
      locked: true,
    }
  );
};

export const useScenarioEntityFilters = (): ScreenerFilter[] => {
  const { filterGroups: screenerFilterGroups } = useScreenerStore(state => ({
    filterGroups: state.filterGroups,
  }));

  const screenerMarketFilters = screenerFilterGroups['Market Filters'];
  const screenerKnowledgeGraphFilters =
    screenerFilterGroups['Knowledge Graph Filters'];

  const marketFilterKeys = ['market_index'];
  const knowledgeGraphKeys = ['theme_exposure'];

  const [indexFilter] = marketFilterKeys.map(key =>
    mapFilter(screenerMarketFilters, key)
  );
  const gicsFilter = mapFilter(screenerMarketFilters, 'gics');
  const [themeExposureFilter] = knowledgeGraphKeys.map(key =>
    mapFilter(screenerKnowledgeGraphFilters, key)
  );

  return [
    watchlistFilter,
    screenerFilter,
    indexFilter,
    gicsFilter,
    themeExposureFilter,
  ].filter(x => !!x);
};
